var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "deliverable-listing",
      class: {
        hasFilter:
          _vm.filterQuery.status.length ||
          _vm.filterQuery.coordinator.length ||
          _vm.filterQuery.tag.length ||
          _vm.filterQuery.outlet.length
      }
    },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleUpdateModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            attrs: { title: _vm.viewBtnLabel, viewId: _vm.activeView },
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createContactModal",
            title: "New Contact"
          },
          on: { shown: _vm.focusContactModal }
        },
        [_c("CreateContactModal", { ref: "refContactModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editContactModal",
            title: "Update Contact"
          },
          on: { shown: _vm.focusUpdateContactModal }
        },
        [_c("UpdateContactModal", { ref: "refUpdateContactModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createSpokespersonModal",
            title: "New Spokesperson"
          },
          on: { shown: _vm.focusSpokespersonModal }
        },
        [_c("CreateSpokespersonModal", { ref: "refSpokespersonModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createWhoModal",
            title: "New Outlet / Contact"
          },
          on: { shown: _vm.focusWhoModal }
        },
        [_c("CreateWhoModal", { ref: "refWhoModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editSpokespersonModal",
            title: "Update Spokesperson"
          },
          on: { shown: _vm.focusUpdateSpokespersonModal }
        },
        [_c("UpdateSpokespersonModal", { ref: "refUpdateSpokespersonModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editWhoModal",
            title: "Update Outlet / Contact"
          },
          on: { shown: _vm.focusUpdateWhoModal }
        },
        [_c("UpdateWhoModal", { ref: "refUpdateWhoModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: ""
          },
          on: {
            hide: _vm.editDeliverableModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: { allContacts: _vm.allContacts }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModal",
            title: "Edit Social Deliverable"
          },
          on: {
            hide: _vm.editSocialModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [_c("EditSocialModal", { ref: "refEditSocialModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "deleteDeliverableConfirmModal",
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: _vm.onConfirmRemoveDeliverable,
            cancel: _vm.onCancelRemoveDeliverable
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this deliverable?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "headerViewSelectModal",
            "hide-footer": "",
            title: "Views"
          },
          on: { hidden: _vm.viewSelectModalHidden }
        },
        [
          _c(
            "div",
            {
              staticClass: "saved-views",
              attrs: { id: "header-view-select-modal" }
            },
            [
              _c(
                "div",
                { staticClass: "view-select-title-header" },
                [
                  _c("h4", [_vm._v("Views")]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "d-block",
                      attrs: {
                        variant: "theme",
                        title: "Close View Popup",
                        size: "sm"
                      },
                      on: { click: _vm.closeVuewSelectModal }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view-select-body" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeView != "-1",
                        expression: "activeView != '-1'"
                      }
                    ],
                    staticClass: "dropdown-item clear-view",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        _vm.handleResetFilter()
                        _vm.$bvModal.hide("headerViewSelectModal")
                      }
                    }
                  },
                  [
                    _vm._v("\n\t\t\t\t\tClear View\n\t\t\t\t\t"),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fas fa-cross text-primary" })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewModalShowUpdateView,
                        expression: "viewModalShowUpdateView"
                      }
                    ],
                    staticClass: "dropdown-item update-view",
                    attrs: { href: "#" },
                    on: { click: _vm.modalUpdateView }
                  },
                  [
                    _vm._v("\n\t\t\t\t\tUpdate View\n\t\t\t\t\t"),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "far fa-edit text-primary" })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewModalShowCreateView,
                        expression: "viewModalShowCreateView"
                      }
                    ],
                    staticClass: "dropdown-item save-view",
                    attrs: { href: "#" },
                    on: { click: _vm.modalSaveView }
                  },
                  [
                    _vm._v("\n\t\t\t\t\tSave View\n\t\t\t\t\t"),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", {
                        staticClass: "fas fa-plus-circle text-primary"
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showNewViewTitleArea
                  ? _c(
                      "div",
                      { staticClass: "new-view-title-area" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h5", [_vm._v("Save View")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ViewTitleModal", {
                          attrs: { hasCancelButton: true },
                          on: {
                            setActiveView: _vm.setActiveView,
                            cancelEdit: function($event) {
                              _vm.showNewViewTitleArea = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUpdateViewTitleArea
                  ? _c(
                      "div",
                      { staticClass: "update-view-title-area" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h5", [_vm._v("Update View")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ViewTitleModal", {
                          attrs: {
                            title: _vm.viewBtnLabel,
                            viewId: _vm.activeView,
                            hasCancelButton: true
                          },
                          on: {
                            setActiveView: _vm.setActiveView,
                            cancelEdit: function($event) {
                              _vm.showUpdateViewTitleArea = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showNewViewTitleArea && !_vm.showUpdateViewTitleArea
                  ? _c(
                      "div",
                      { ref: "views__scroll", staticClass: "views__scroll" },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              scroll__view__btns:
                                !_vm.viewModalShowCreateView &&
                                !_vm.viewModalShowUpdateView
                            }
                          },
                          [
                            _vm._l(_vm.presetViewsMyWeek, function(
                              userView,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key: "userView" + index + 1 * Math.random(),
                                  staticClass: "dropdown-item",
                                  class: {
                                    active: _vm.activeView == userView.id
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadViewFromModal(
                                        userView,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "preset-icon-wrap"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "save-title" }, [
                                    _vm._v(_vm._s(userView.title))
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.userViewsDeliverable, function(
                              userView,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key: "userView" + index + 1 * Math.random(),
                                  staticClass: "dropdown-item",
                                  class: {
                                    active: _vm.activeView == userView.id
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadViewFromModal(
                                        userView,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "remove-icon-wrap" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "remove-icon",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.removeView(userView.id)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-trash"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "save-title" }, [
                                    _vm._v(_vm._s(userView.title))
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.myWeek
        ? _c(
            "div",
            { staticClass: "my__week__list" },
            [
              _c(
                "div",
                { staticClass: "deliverable-header" },
                [
                  _c("HeaderIcon", { attrs: { myWeek: _vm.myWeek } }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-inline-block float-right saved-views-area",
                      class: [
                        !_vm.showUpdateViewText ? "pt-15" : "",
                        _vm.activeView != "-1" ? "saved-view-active" : ""
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showUpdateViewText,
                              expression: "showUpdateViewText"
                            }
                          ],
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: { click: _vm.directUpdateView }
                            },
                            [_vm._v("Click here")]
                          ),
                          _vm._v(" to save updated view\n\t\t\t\t")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-group float-right add-new__global_search sorting saved-views"
                        },
                        [
                          !_vm.showCreateNewView
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-theme ml-2 header-filter-btns dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  },
                                  on: { click: _vm.updatePerfectScroll }
                                },
                                [
                                  _vm.showUpdateViewText
                                    ? _c("span", {
                                        staticClass: "updated-view"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "mr-3 view__label truncate-text"
                                    },
                                    [_vm._v(_vm._s(_vm.viewBtnLabel))]
                                  ),
                                  _vm._v(" "),
                                  _vm.activeView == "-1"
                                    ? _c("i", {
                                        staticClass:
                                          "fas fa-fw fa-eye text-primary float-right"
                                      })
                                    : _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value: {
                                              customClass: "save__view__tooltip"
                                            },
                                            expression:
                                              "{customClass: 'save__view__tooltip'}",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass:
                                          "fas fa-fw fa-eye text-primary float-right",
                                        attrs: { title: "Clear View" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleResetFilter()
                                          }
                                        }
                                      })
                                ]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  }
                                },
                                [
                                  _vm.showUpdateViewText
                                    ? _c("span", {
                                        staticClass: "updated-view"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mr-3 view__label" },
                                    [_vm._v("Views")]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        value: {
                                          customClass: "save__view__tooltip"
                                        },
                                        expression:
                                          "{ customClass: 'save__view__tooltip' }",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "fas fa-fw fa-eye text-primary float-right",
                                    attrs: { title: "Save View" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.saveView.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-menu viewmenu-dropdown" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item update-view",
                                      attrs: { href: "#" },
                                      on: { click: _vm.updateView }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tUpdate View\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._m(0)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item save-view",
                                      attrs: { href: "#" },
                                      on: { click: _vm.saveView }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tSave View\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._m(1)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "perfect-scrollbar",
                                    {
                                      ref: "views__scroll",
                                      staticClass: "views__scroll"
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _vm._l(
                                            _vm.presetViewsMyWeek,
                                            function(userView, index) {
                                              return _c(
                                                "a",
                                                {
                                                  key:
                                                    "userView" +
                                                    index +
                                                    1 * Math.random(),
                                                  staticClass: "dropdown-item",
                                                  class: {
                                                    active:
                                                      _vm.activeView ==
                                                      userView.id
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.loadView(
                                                        userView,
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "preset-icon-wrap"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "save-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(userView.title)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.userViewsDeliverable,
                                            function(userView, index) {
                                              return _c(
                                                "a",
                                                {
                                                  key:
                                                    "userView" +
                                                    index +
                                                    1 * Math.random(),
                                                  staticClass: "dropdown-item",
                                                  class: {
                                                    active:
                                                      _vm.activeView ==
                                                      userView.id
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.loadView(
                                                        userView,
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "remove-icon-wrap"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "remove-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.removeView(
                                                                userView.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-trash"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "save-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(userView.title)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-inline-block float-right pt-15 mr-3 expand-all-area"
                    },
                    [
                      _vm.$router.currentRoute.name != "globalSearch" &&
                      _vm.$router.currentRoute.name != "calendar"
                        ? _c(
                            "div",
                            {
                              staticClass: "ml-2 expand-grp cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.toggleStatusView(!_vm.expandAll)
                                }
                              }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "header-filter-btns expand-ctrls",
                                  class: { "none-active-btn": _vm.expandAll },
                                  attrs: { variant: "theme", title: "Expand" }
                                },
                                [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v("Expand All ")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-expand fa-fw"
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "header-filter-btns expand-ctrls",
                                  class: { "none-active-btn": !_vm.expandAll },
                                  attrs: { variant: "theme", title: "Collapse" }
                                },
                                [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v("Collapse All")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-compress fa-fw"
                                    })
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.deliverablesArray, function(group, index) {
                return group.length
                  ? _c(
                      "div",
                      { key: index, staticClass: "mb-5" },
                      [
                        _c("h2", { staticClass: "deliverable-group-my-week" }, [
                          _vm._v(
                            _vm._s(_vm._.startCase(index)) +
                              " (" +
                              _vm._s(_vm.deliverableCount[index]) +
                              ")"
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(group, function(deliverable, index) {
                          return _c(
                            "div",
                            {
                              key: "deliverable" + index,
                              staticClass: "deliverable-block",
                              class:
                                !_vm.userAbilities.editMediaCall ||
                                deliverable.permissions.viewOnly
                                  ? "read-only"
                                  : ""
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "delv-block-resp" },
                                [
                                  _c("DuplicateMediaCallBtn", {
                                    attrs: { deliverableId: deliverable.id }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-row dbox-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dbox-left-side dleft-inner-wrap"
                                        },
                                        [
                                          _vm.isSocialMedia(deliverable)
                                            ? _c(
                                                "div",
                                                { staticClass: "top-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "data-items"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.deliverableTypeTitle(
                                                                deliverable.deliverable_template_id
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items hide-mobile social-campaigns"
                                                    },
                                                    [
                                                      _c(
                                                        "SocialDeliverableCampaigns",
                                                        {
                                                          attrs: {
                                                            deliverable: deliverable
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items hide-mobile social-series"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "department-label"
                                                        },
                                                        [_vm._v("SERIES: ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "department-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getSeriesNameByDeliverable(
                                                                deliverable
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items hide-mobile"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("POST DATE:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "post-date-value"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.displaySocialPublishDate(
                                                                deliverable.publish_date
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._m(2, true)
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "top-row" },
                                                [
                                                  !_vm.canChangeDeliverableType()
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "data-items"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.deliverableTypeTitle(
                                                                    deliverable.deliverable_template_id
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "data-items deliverable-type-link",
                                                          attrs: {
                                                            "data-toggle":
                                                              "dropdown"
                                                          }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.deliverableTypeTitle(
                                                                    deliverable.deliverable_template_id
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "dropdown-menu"
                                                            },
                                                            _vm._l(
                                                              _vm.deliverableTypes,
                                                              function(
                                                                type,
                                                                i
                                                              ) {
                                                                return _c(
                                                                  "a",
                                                                  {
                                                                    key: i,
                                                                    staticClass:
                                                                      "dropdown-item",
                                                                    attrs: {
                                                                      href: "#"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.changeDeliverableType(
                                                                          deliverable,
                                                                          type
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        type.name
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "data-items hide-mobile"
                                                      },
                                                      [
                                                        _c(
                                                          "DeliverableProjects",
                                                          {
                                                            attrs: {
                                                              deliverable: deliverable
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.hasPriorityField(
                                                      deliverable
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items hide-mobile"
                                                          },
                                                          [
                                                            _c("span", {}, [
                                                              _vm._v(
                                                                "PRIORITY: "
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "b-tooltip",
                                                                    rawName:
                                                                      "v-b-tooltip.hover",
                                                                    modifiers: {
                                                                      hover: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "listing-priority",
                                                                class:
                                                                  "listing-priority-del-" +
                                                                  deliverable.id,
                                                                attrs: {
                                                                  title:
                                                                    "Priority"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setPriority(
                                                                      deliverable,
                                                                      false
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "vue-star-rate",
                                                                  {
                                                                    key:
                                                                      "del-rating-" +
                                                                      Math.random() +
                                                                      deliverable.id,
                                                                    attrs: {
                                                                      rateRange: deliverable.priority
                                                                        ? Number(
                                                                            deliverable.priority
                                                                          )
                                                                        : 0,
                                                                      maxIcon: 5,
                                                                      iconHeight: 17,
                                                                      iconWidth: 17,
                                                                      hasCounter: false,
                                                                      iconColor:
                                                                        "#ffffff",
                                                                      iconColorHover:
                                                                        "#ffffff",
                                                                      iconShape:
                                                                        "circle"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.showAltStartEndDate(
                                                      deliverable
                                                    )
                                                      ? [
                                                          _vm._l(
                                                            _vm._.filter(
                                                              deliverable.customFields,
                                                              {
                                                                field_key:
                                                                  "start_date"
                                                              }
                                                            ),
                                                            function(
                                                              field,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "data-items hide-mobile"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {},
                                                                    [
                                                                      _vm._v(
                                                                        "START DATE:"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          field.value,
                                                                          "DD MMM, YYYY"
                                                                        )
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._.filter(
                                                            deliverable.customFields,
                                                            {
                                                              field_key:
                                                                "start_date"
                                                            }
                                                          ).length == 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "data-items hide-mobile"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {},
                                                                    [
                                                                      _vm._v(
                                                                        "START DATE:"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "data-items hide-mobile"
                                                            },
                                                            [
                                                              _c("span", {}, [
                                                                _vm._v(
                                                                  "END DATE:"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _vm.calculateEndDate(
                                                                deliverable
                                                              )
                                                                ? [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "moment"
                                                                          )(
                                                                            _vm.calculateEndDate(
                                                                              deliverable
                                                                            ),
                                                                            "DD MMM, YYYY"
                                                                          )
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "data-items hide-mobile"
                                                            },
                                                            [
                                                              _c("span", {}, [
                                                                _vm._v(
                                                                  "STARTED:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      deliverable.created_at,
                                                                      "DD MMM, YYYY @ H:mm"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          deliverable.all_completed
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "data-items hide-mobile"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {},
                                                                    [
                                                                      _vm._v(
                                                                        "COMPLETED:"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          deliverable.completed_at,
                                                                          "DD MMM, YYYY @ H:mm"
                                                                        )
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "data-items hide-mobile"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {},
                                                                    [
                                                                      _vm._v(
                                                                        "LAST MODIFIED:"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          deliverable.updated_at,
                                                                          "DD MMM, YYYY @ H:mm"
                                                                        )
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                  ]
                                                ],
                                                2
                                              ),
                                          _vm._v(" "),
                                          _c("DeliverableTypeIcon", {
                                            attrs: {
                                              deliverableTypeId:
                                                deliverable.deliverable_template_id
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row mobile-deli-info"
                                            },
                                            [
                                              _vm.hasPriorityField(deliverable)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items deliverable-priority"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [_vm._v("PRIORITY: ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover",
                                                              modifiers: {
                                                                hover: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "listing-priority",
                                                          class:
                                                            "listing-priority-del-" +
                                                            deliverable.id,
                                                          attrs: {
                                                            title: "Priority"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.setPriority(
                                                                deliverable,
                                                                true
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("vue-star-rate", {
                                                            key:
                                                              "del-rating-" +
                                                              Math.random() +
                                                              deliverable.id,
                                                            attrs: {
                                                              rateRange: deliverable.priority
                                                                ? Number(
                                                                    deliverable.priority
                                                                  )
                                                                : 0,
                                                              maxIcon: 5,
                                                              iconHeight: 17,
                                                              iconWidth: 17,
                                                              hasCounter: false,
                                                              iconColor:
                                                                "#4C9850",
                                                              iconColorHover:
                                                                "#4C9850",
                                                              iconShape:
                                                                "circle"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showAltStartEndDate(
                                                deliverable
                                              )
                                                ? [
                                                    _vm._l(
                                                      _vm._.filter(
                                                        deliverable.customFields,
                                                        {
                                                          field_key:
                                                            "start_date"
                                                        }
                                                      ),
                                                      function(field, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "data-items deliverable-start"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-primary"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "START DATE:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    field.value,
                                                                    "DD MMM, YYYY"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._.filter(
                                                      deliverable.customFields,
                                                      {
                                                        field_key: "start_date"
                                                      }
                                                    ).length == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items deliverable-start"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-primary"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "START DATE:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "data-items deliverable-end"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-primary"
                                                          },
                                                          [_vm._v("END DATE:")]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.calculateEndDate(
                                                          deliverable
                                                        )
                                                          ? [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      _vm.calculateEndDate(
                                                                        deliverable
                                                                      ),
                                                                      "DD MMM, YYYY"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          : [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "data-items deliverable-start"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-primary"
                                                          },
                                                          [_vm._v("STARTED:")]
                                                        ),
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                deliverable.created_at,
                                                                "DD MMM, YYYY @ H:mm"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    deliverable.all_completed
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-primary deliverable-end"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "COMPLETED:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    deliverable.completed_at,
                                                                    "DD MMM, YYYY @ H:mm"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items deliverable-last-mod"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-primary"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "LAST MODIFIED:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    deliverable.updated_at,
                                                                    "DD MMM, YYYY @ H:mm"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "data-items no-padding deliverable-tags"
                                                },
                                                [
                                                  _c("DeliverableListTags", {
                                                    staticClass:
                                                      "deliverable-list-tags",
                                                    attrs: {
                                                      deliverable: deliverable
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "data-items deliverable-project"
                                                },
                                                [
                                                  _c("DeliverableProjects", {
                                                    attrs: {
                                                      deliverable: deliverable
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "row listing-row" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    "col-md-8 titles breakpoint__fix " +
                                                    (_vm.isSocialMedia(
                                                      deliverable
                                                    )
                                                      ? "social-titles"
                                                      : "") +
                                                    " " +
                                                    (_vm.isSeriesMaster(
                                                      deliverable
                                                    )
                                                      ? "series-master"
                                                      : ""),
                                                  style: _vm.infoColStyle(
                                                    deliverable
                                                  )
                                                },
                                                [
                                                  _vm.showDepartment(
                                                    deliverable
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "inside-list department--wrap--new"
                                                        },
                                                        [
                                                          _c(
                                                            "DeliverableDepartments",
                                                            {
                                                              attrs: {
                                                                deliverable: deliverable
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      class:
                                                        "deliverable-title edit-d-title " +
                                                        (_vm.showDepartment(
                                                          deliverable
                                                        )
                                                          ? ""
                                                          : "no-depart"),
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showModalFn(
                                                            deliverable
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            deliverable.title ||
                                                              "Click to set..."
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mobile-task-expand-button-area"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mobile-task-exp-btn"
                                                        },
                                                        [
                                                          _c(
                                                            "CollapseTaskBtn",
                                                            {
                                                              attrs: {
                                                                deliverable: deliverable,
                                                                index:
                                                                  deliverable.id,
                                                                expandAll:
                                                                  _vm.expandAll
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.userCanEditDeliverable()
                                                    ? _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover",
                                                              modifiers: {
                                                                hover: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "delete-bar",
                                                          attrs: {
                                                            title: "Delete"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.deleteDeliverableClick(
                                                                deliverable
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._m(3, true)]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.isMobile() &&
                                              _vm.isSocialMedia(deliverable)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-4 infos publish-status"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-row",
                                                          style: _vm.getPublishStatusStyle(
                                                            deliverable.publish_status
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "PublishStatusListLabel",
                                                            {
                                                              attrs: {
                                                                deliverable: deliverable
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isMobile() &&
                                              !_vm.isSocialMedia(deliverable)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-4 infos"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-row"
                                                        },
                                                        [
                                                          _vm.showInfoCol(
                                                            deliverable
                                                          )
                                                            ? _c(
                                                                "DeliverableListCoordinators",
                                                                {
                                                                  staticClass:
                                                                    "deliverable-list-coordinators",
                                                                  attrs: {
                                                                    deliverable: deliverable
                                                                  }
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.showInfoCol(
                                                            deliverable
                                                          )
                                                            ? _c(
                                                                "DeliverableListContacts",
                                                                {
                                                                  staticClass:
                                                                    "deliverable-list-contacts",
                                                                  attrs: {
                                                                    deliverable: deliverable
                                                                  }
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "DeliverableListTags",
                                                            {
                                                              staticClass:
                                                                "deliverable-list-tags",
                                                              attrs: {
                                                                deliverable: deliverable
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "DeliverableStatusOverview",
                                                            {
                                                              attrs: {
                                                                deliverable: deliverable
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "b-collapse",
                                                      {
                                                        attrs: {
                                                          visible:
                                                            _vm.expandAll,
                                                          id:
                                                            "task-listing-collapse-" +
                                                            deliverable.id
                                                        }
                                                      },
                                                      [
                                                        _vm.isMobile()
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-12 infos responsive-infos"
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "d-flex flex-row"
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("TaskFieldLabels", {
                                                          attrs: {
                                                            fullDeliverables:
                                                              _vm.deliverablesArray,
                                                            tasks:
                                                              deliverable.tasks,
                                                            deliverableId:
                                                              deliverable.id,
                                                            deliverable: deliverable
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("TaskFields", {
                                                          attrs: {
                                                            fullDeliverables:
                                                              _vm.deliverablesArray,
                                                            deliverable: deliverable,
                                                            deliverableId:
                                                              deliverable.id,
                                                            myWeek: true,
                                                            tasks:
                                                              deliverable.tasks,
                                                            users:
                                                              deliverable.users
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dbox-right-side dright-inner-wrap"
                                        },
                                        [
                                          _c("CollapseTaskBtn", {
                                            attrs: {
                                              deliverable: deliverable,
                                              index: deliverable.id,
                                              expandAll: _vm.expandAll
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              !_vm.hasMyWeek()
                ? _c("div", { staticClass: "mb-5" }, [
                    _c("h2", [_vm._v("No tasks")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("pagination", {
                    attrs: {
                      data: _vm.userDeliverablesPaginationData,
                      limit: 5
                    },
                    on: { "pagination-change-page": _vm.onChangePage }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.myWeek
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "deliverable-header" },
                [
                  _c("HeaderIcon", {
                    attrs: {
                      totalDeliverableCount: this.allDeliverablesPaginationData
                        .total
                        ? this.allDeliverablesPaginationData.total
                        : 0,
                      totalOutletCount: this.outletCount ? this.outletCount : 0,
                      myWeek: _vm.myWeek
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-inline-block float-right saved-views-area",
                      class: [
                        !_vm.showUpdateViewText ? "pt-15" : "",
                        _vm.activeView != "-1" ? "saved-view-active" : ""
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showUpdateViewText,
                              expression: "showUpdateViewText"
                            }
                          ],
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: { click: _vm.directUpdateView }
                            },
                            [_vm._v("Click here")]
                          ),
                          _vm._v(" to save updated view\n\t\t\t\t")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-group float-right add-new__global_search sorting saved-views"
                        },
                        [
                          !_vm.showCreateNewView
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-theme ml-2 header-filter-btns dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  },
                                  on: { click: _vm.updatePerfectScroll }
                                },
                                [
                                  _vm.showUpdateViewText
                                    ? _c("span", {
                                        staticClass: "updated-view"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "mr-3 view__label truncate-text"
                                    },
                                    [_vm._v(_vm._s(_vm.viewBtnLabel))]
                                  ),
                                  _vm._v(" "),
                                  _vm.activeView == "-1"
                                    ? _c("i", {
                                        staticClass:
                                          "fas fa-fw fa-eye text-primary float-right"
                                      })
                                    : _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value: {
                                              customClass: "save__view__tooltip"
                                            },
                                            expression:
                                              "{customClass: 'save__view__tooltip'}",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass:
                                          "fas fa-fw fa-eye text-primary float-right",
                                        attrs: { title: "Clear View" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleResetFilter()
                                          }
                                        }
                                      })
                                ]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  }
                                },
                                [
                                  _vm.showUpdateViewText
                                    ? _c("span", {
                                        staticClass: "updated-view"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mr-3 view__label" },
                                    [_vm._v("Views")]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        value: {
                                          customClass: "save__view__tooltip"
                                        },
                                        expression:
                                          "{ customClass: 'save__view__tooltip' }",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "fas fa-fw fa-eye text-primary float-right",
                                    attrs: { title: "Save View" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.saveView.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-menu viewmenu-dropdown" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item update-view",
                                      attrs: { href: "#" },
                                      on: { click: _vm.updateView }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tUpdate View\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._m(4)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item save-view",
                                      attrs: { href: "#" },
                                      on: { click: _vm.saveView }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tSave View\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._m(5)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "perfect-scrollbar",
                                    {
                                      ref: "views__scroll",
                                      staticClass: "views__scroll"
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _vm._l(
                                            _vm.presetViewsDashboard,
                                            function(userView, index) {
                                              return _c(
                                                "a",
                                                {
                                                  key:
                                                    "userView" +
                                                    index +
                                                    1 * Math.random(),
                                                  staticClass: "dropdown-item",
                                                  class: {
                                                    active:
                                                      _vm.activeView ==
                                                      userView.id
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.loadView(
                                                        userView,
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "preset-icon-wrap"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "save-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(userView.title)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.userViewsDeliverable,
                                            function(userView, index) {
                                              return _c(
                                                "a",
                                                {
                                                  key:
                                                    "userView" +
                                                    index +
                                                    1 * Math.random(),
                                                  staticClass: "dropdown-item",
                                                  class: {
                                                    active:
                                                      _vm.activeView ==
                                                      userView.id
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.loadView(
                                                        userView,
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "remove-icon-wrap"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "remove-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.removeView(
                                                                userView.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-trash"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "save-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(userView.title)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-inline-block float-right pt-15 mr-3 expand-all-area"
                    },
                    [
                      _vm.$router.currentRoute.name != "globalSearch" &&
                      _vm.$router.currentRoute.name != "calendar"
                        ? _c(
                            "div",
                            {
                              staticClass: "ml-2 expand-grp cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.toggleStatusView(!_vm.expandAll)
                                }
                              }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "header-filter-btns expand-ctrls",
                                  class: { "none-active-btn": _vm.expandAll },
                                  attrs: { variant: "theme", title: "Expand" }
                                },
                                [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v("Expand All ")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-expand fa-fw"
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "header-filter-btns expand-ctrls",
                                  class: { "none-active-btn": !_vm.expandAll },
                                  attrs: { variant: "theme", title: "Collapse" }
                                },
                                [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v("Collapse All")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-compress fa-fw"
                                    })
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.deliverablesArray, function(deliverable, index) {
                return index != "totalOutlets"
                  ? _c(
                      "div",
                      {
                        key: "deliverable" + index,
                        staticClass: "deliverable-block",
                        class:
                          !_vm.userAbilities.editMediaCall ||
                          deliverable.permissions.viewOnly
                            ? "read-only"
                            : ""
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "delv-block-resp" },
                          [
                            _c("DuplicateMediaCallBtn", {
                              attrs: { deliverableId: deliverable.id }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-row dbox-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dbox-left-side dleft-inner-wrap"
                                  },
                                  [
                                    _vm.isSocialMedia(deliverable)
                                      ? _c("div", { staticClass: "top-row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "data-items" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.deliverableTypeTitle(
                                                        deliverable.deliverable_template_id
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "data-items hide-mobile social-campaigns"
                                            },
                                            [
                                              _c("SocialDeliverableCampaigns", {
                                                attrs: {
                                                  deliverable: deliverable
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "data-items hide-mobile social-series"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "department-label"
                                                },
                                                [_vm._v("SERIES: ")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "department-title"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getSeriesNameByDeliverable(
                                                        deliverable
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "data-items hide-mobile"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("POST DATE:")
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "post-date-value"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displaySocialPublishDate(
                                                        deliverable.publish_date
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(6, true)
                                        ])
                                      : _c(
                                          "div",
                                          { staticClass: "top-row" },
                                          [
                                            !_vm.canChangeDeliverableType()
                                              ? _c(
                                                  "div",
                                                  { staticClass: "data-items" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.deliverableTypeTitle(
                                                              deliverable.deliverable_template_id
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "data-items deliverable-type-link",
                                                    attrs: {
                                                      "data-toggle": "dropdown"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.deliverableTypeTitle(
                                                              deliverable.deliverable_template_id
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-menu"
                                                      },
                                                      _vm._l(
                                                        _vm.deliverableTypes,
                                                        function(type, i) {
                                                          return _c(
                                                            "a",
                                                            {
                                                              key: i,
                                                              staticClass:
                                                                "dropdown-item",
                                                              attrs: {
                                                                href: "#"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.changeDeliverableType(
                                                                    deliverable,
                                                                    type
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  type.name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "data-items hide-mobile"
                                                },
                                                [
                                                  _c("DeliverableProjects", {
                                                    attrs: {
                                                      deliverable: deliverable
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.hasPriorityField(deliverable)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items hide-mobile"
                                                    },
                                                    [
                                                      _c("span", {}, [
                                                        _vm._v("PRIORITY: ")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover",
                                                              modifiers: {
                                                                hover: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "listing-priority",
                                                          class:
                                                            "listing-priority-del-" +
                                                            deliverable.id,
                                                          attrs: {
                                                            title: "Priority"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.setPriority(
                                                                deliverable,
                                                                false
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("vue-star-rate", {
                                                            key:
                                                              "del-rating-" +
                                                              Math.random() +
                                                              deliverable.id,
                                                            attrs: {
                                                              rateRange: deliverable.priority
                                                                ? Number(
                                                                    deliverable.priority
                                                                  )
                                                                : 0,
                                                              maxIcon: 5,
                                                              iconHeight: 17,
                                                              iconWidth: 17,
                                                              hasCounter: false,
                                                              iconColor:
                                                                "#ffffff",
                                                              iconColorHover:
                                                                "#ffffff",
                                                              iconShape:
                                                                "circle"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showAltStartEndDate(
                                                deliverable
                                              )
                                                ? [
                                                    _vm._l(
                                                      _vm._.filter(
                                                        deliverable.customFields,
                                                        {
                                                          field_key:
                                                            "start_date"
                                                        }
                                                      ),
                                                      function(field, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "data-items hide-mobile"
                                                          },
                                                          [
                                                            _c("span", {}, [
                                                              _vm._v(
                                                                "START DATE:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    field.value,
                                                                    "DD MMM, YYYY"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._.filter(
                                                      deliverable.customFields,
                                                      {
                                                        field_key: "start_date"
                                                      }
                                                    ).length == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items hide-mobile"
                                                          },
                                                          [
                                                            _c("span", {}, [
                                                              _vm._v(
                                                                "START DATE:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "data-items hide-mobile"
                                                      },
                                                      [
                                                        _c("span", {}, [
                                                          _vm._v("END DATE:")
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm.calculateEndDate(
                                                          deliverable
                                                        )
                                                          ? [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      _vm.calculateEndDate(
                                                                        deliverable
                                                                      ),
                                                                      "DD MMM, YYYY"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          : [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "data-items hide-mobile"
                                                      },
                                                      [
                                                        _c("span", {}, [
                                                          _vm._v("STARTED:")
                                                        ]),
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                deliverable.created_at,
                                                                "DD MMM, YYYY @ H:mm"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    deliverable.all_completed
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items hide-mobile"
                                                          },
                                                          [
                                                            _c("span", {}, [
                                                              _vm._v(
                                                                "COMPLETED:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    deliverable.completed_at,
                                                                    "DD MMM, YYYY @ H:mm"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-items hide-mobile"
                                                          },
                                                          [
                                                            _c("span", {}, [
                                                              _vm._v(
                                                                "LAST MODIFIED:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    deliverable.updated_at,
                                                                    "DD MMM, YYYY @ H:mm"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                  ]
                                            ]
                                          ],
                                          2
                                        ),
                                    _vm._v(" "),
                                    _c("DeliverableTypeIcon", {
                                      attrs: {
                                        deliverableTypeId:
                                          deliverable.deliverable_template_id
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row mobile-deli-info" },
                                      [
                                        _vm.hasPriorityField(deliverable)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "data-items deliverable-priority"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-primary"
                                                  },
                                                  [_vm._v("PRIORITY: ")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "listing-priority",
                                                    class:
                                                      "listing-priority-del-" +
                                                      deliverable.id,
                                                    attrs: {
                                                      title: "Priority"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setPriority(
                                                          deliverable,
                                                          true
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("vue-star-rate", {
                                                      key:
                                                        "del-rating-" +
                                                        Math.random() +
                                                        deliverable.id,
                                                      attrs: {
                                                        rateRange: deliverable.priority
                                                          ? Number(
                                                              deliverable.priority
                                                            )
                                                          : 0,
                                                        maxIcon: 5,
                                                        iconHeight: 17,
                                                        iconWidth: 17,
                                                        hasCounter: false,
                                                        iconColor: "#4C9850",
                                                        iconColorHover:
                                                          "#4C9850",
                                                        iconShape: "circle"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showAltStartEndDate(deliverable)
                                          ? [
                                              _vm._l(
                                                _vm._.filter(
                                                  deliverable.customFields,
                                                  { field_key: "start_date" }
                                                ),
                                                function(field, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "data-items deliverable-start"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [_vm._v("START DATE:")]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm._f("moment")(
                                                              field.value,
                                                              "DD MMM, YYYY"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._.filter(
                                                deliverable.customFields,
                                                { field_key: "start_date" }
                                              ).length == 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items deliverable-start"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [_vm._v("START DATE:")]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "data-items deliverable-end"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-primary"
                                                    },
                                                    [_vm._v("END DATE:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.calculateEndDate(
                                                    deliverable
                                                  )
                                                    ? [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                _vm.calculateEndDate(
                                                                  deliverable
                                                                ),
                                                                "DD MMM, YYYY"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "data-items" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-primary deliverable-start"
                                                    },
                                                    [_vm._v("STARTED:")]
                                                  ),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          deliverable.created_at,
                                                          "DD MMM, YYYY @ H:mm"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              deliverable.all_completed
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items deliverable-completed"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [_vm._v("COMPLETED:")]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm._f("moment")(
                                                              deliverable.completed_at,
                                                              "DD MMM, YYYY @ H:mm"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "data-items deliverable-last-mod"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "LAST MODIFIED:"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm._f("moment")(
                                                              deliverable.updated_at,
                                                              "DD MMM, YYYY @ H:mm"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                            ],
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data-items no-padding deliverable-tags"
                                          },
                                          [
                                            _c("DeliverableListTags", {
                                              staticClass:
                                                "deliverable-list-tags",
                                              attrs: {
                                                deliverable: deliverable
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data-items deliverable-project"
                                          },
                                          [
                                            _c("DeliverableProjects", {
                                              attrs: {
                                                deliverable: deliverable
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row listing-row" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              "col-md-8 titles breakpoint__fix " +
                                              (_vm.isSocialMedia(deliverable)
                                                ? "social-titles"
                                                : ""),
                                            style: _vm.infoColStyle(deliverable)
                                          },
                                          [
                                            _vm.showDepartment(deliverable)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "inside-list department--wrap--new"
                                                  },
                                                  [
                                                    _c(
                                                      "DeliverableDepartments",
                                                      {
                                                        attrs: {
                                                          deliverable: deliverable
                                                        }
                                                      }
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                class:
                                                  "deliverable-title edit-d-title " +
                                                  (_vm.showDepartment(
                                                    deliverable
                                                  )
                                                    ? ""
                                                    : "no-depart"),
                                                on: {
                                                  click: function($event) {
                                                    return _vm.showModalFn(
                                                      deliverable
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(deliverable.title) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mobile-task-expand-button-area"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mobile-task-exp-btn"
                                                  },
                                                  [
                                                    _c("CollapseTaskBtn", {
                                                      attrs: {
                                                        deliverable: deliverable,
                                                        index: index,
                                                        expandAll: _vm.expandAll
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.userCanEditDeliverable()
                                              ? _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      },
                                                      {
                                                        name: "click-outside",
                                                        rawName:
                                                          "v-click-outside",
                                                        value: _vm.deleteDeliverableClickOutside(
                                                          deliverable.id
                                                        ),
                                                        expression:
                                                          "deleteDeliverableClickOutside(deliverable.id)"
                                                      }
                                                    ],
                                                    class:
                                                      "delete-bar " +
                                                      (deliverable.id ==
                                                      _vm.stripRemoveDeliverableId
                                                        ? "hovered"
                                                        : ""),
                                                    attrs: { title: "Delete" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleteDeliverableClick(
                                                          deliverable
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._m(7, true)]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isMobile() &&
                                        _vm.isSocialMedia(deliverable)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-4 infos publish-status"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-row",
                                                    style: _vm.getPublishStatusStyle(
                                                      deliverable.publish_status
                                                    )
                                                  },
                                                  [
                                                    _c(
                                                      "PublishStatusListLabel",
                                                      {
                                                        attrs: {
                                                          deliverable: deliverable
                                                        }
                                                      }
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isMobile() &&
                                        !_vm.isSocialMedia(deliverable)
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 infos" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-row"
                                                  },
                                                  [
                                                    _vm.showInfoCol(deliverable)
                                                      ? _c(
                                                          "DeliverableListCoordinators",
                                                          {
                                                            staticClass:
                                                              "deliverable-list-coordinators",
                                                            attrs: {
                                                              deliverable: deliverable
                                                            }
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.showInfoCol(deliverable)
                                                      ? _c(
                                                          "DeliverableListContacts",
                                                          {
                                                            staticClass:
                                                              "deliverable-list-contacts",
                                                            attrs: {
                                                              deliverable: deliverable
                                                            }
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("DeliverableListTags", {
                                                      staticClass:
                                                        "deliverable-list-tags",
                                                      attrs: {
                                                        deliverable: deliverable
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "DeliverableStatusOverview",
                                                      {
                                                        attrs: {
                                                          deliverable: deliverable
                                                        }
                                                      }
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-md-12" }, [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "b-collapse",
                                              {
                                                attrs: {
                                                  visible: _vm.expandAll,
                                                  id:
                                                    "task-listing-collapse-" +
                                                    index
                                                }
                                              },
                                              [
                                                _vm.isMobile()
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-6 infos responsive-infos"
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "d-flex flex-row"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("TaskFieldLabels", {
                                                  attrs: {
                                                    fullDeliverables:
                                                      _vm.deliverablesArray,
                                                    tasks: deliverable.tasks,
                                                    deliverableId:
                                                      deliverable.id,
                                                    deliverable: deliverable
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("TaskFields", {
                                                  attrs: {
                                                    fullDeliverables:
                                                      _vm.deliverablesArray,
                                                    deliverable: deliverable,
                                                    deliverableId:
                                                      deliverable.id,
                                                    myWeek: false,
                                                    tasks: deliverable.tasks,
                                                    users: deliverable.users
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dbox-right-side dright-inner-wrap"
                                  },
                                  [
                                    _c("CollapseTaskBtn", {
                                      attrs: {
                                        deliverable: deliverable,
                                        expandAll: _vm.expandAll,
                                        index: index
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.myWeek,
                      expression: "!myWeek"
                    }
                  ],
                  staticClass: "pagination-wrapper"
                },
                [
                  _c("pagination", {
                    attrs: {
                      data: _vm.allDeliverablesPaginationData,
                      limit: _vm.isMobile() ? 3 : 5,
                      size: _vm.isMobile() ? "small" : "default"
                    },
                    on: { "pagination-change-page": _vm.onChangePage }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "far fa-edit text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "fas fa-plus-circle text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-items social-status hide-mobile" }, [
      _c("span", [_vm._v("STATUS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-trash" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "far fa-edit text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "fas fa-plus-circle text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-items social-status hide-mobile" }, [
      _c("span", [_vm._v("STATUS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-trash" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }